import React, { useEffect, useState } from 'react'
import LowerLeft from './LowerLeft';
import LowerRight from './LowerRight';
import DetilnImg from '../pageStructure/DetilnImg';
import axios from 'axios';
import useGetFacultyImages from '../../hooks/useGetFacultyImages';




const facultyPage={
  heading:'Faculty of Geodesy',
  content:['Welcome to the Geodesy Faculty, where we are dedicated to providing comprehensive training to government, private and individual entities involved in geodetic survey work. Our primary mission is to equip trainee officers and staff with the knowledge and skills required to conduct geodetic survey for horizontal and vertical control work using GNSS, CORS, GPR, High Precision Levelling, Field Astronomy and other related technologies.Our courses cover theoretical concepts of geodetic surveying and are complemented with practical and lab exercises to provide a comprehensive understanding of the subject. We offer various training programs ranging from one week to one year, depending on the course. Additionally, we conduct tailor-made courses to cater specific needs of our clients.At our faculty, participants receive personalized attention and guidance from experienced trainers and ensure that they get a thorough understanding of the subject. Our faculty is committed to providing the highest quality education in the field of Geodesy. We invite you to join us today to take the first step towards a successful career in the geospatial domain.']
}

const FacultyGeodesy = () => {
  const [faculty,setFaculty] = useState(null);
  const [headData, setHeadData] = useState(null);
  const facultyImages = useGetFacultyImages('Faculty_Geodesy');
  
const getFacultyMember = async ()=>{
  try {
    const url = "https://api.nigst.surveyofindia.gov.in/admin/faculty_member_faculty1/Faculty_Geodesy";
    const res = await axios.get(url);
    setFaculty(res?.data?.data)
  } catch (error) {
    console.log(error)
  }
}

 const getHeadFaculty = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/sadmin/view_admin`;
      const res = await axios.get(url);
      const headData = res.data.admins.find(item => item.faculty === 'Faculty_Geodesy');
      setHeadData(headData);
    } catch (error) {
      console.log(error)

    }
  }

useEffect(()=>{
  getFacultyMember();
  getHeadFaculty();
},[])
  return (
<div className='m-2 md:m-1 '>
    <DetilnImg heading={facultyPage.heading} text={facultyPage.content} images={facultyImages} />

    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2  m-4 md:m-6 lg:m-8 rounded-md gap-2 md:gap-4 lg:gap-6'>
      <LowerLeft  headData={headData} />
      <LowerRight data={faculty} />
    </div>
    </div>

  )
}

export default FacultyGeodesy